module.exports = __webpack_public_path__ + "static/media/bed1.d1480702.svg";